import type { ExtendedUser, LoggedUser, SimpleUser } from '@common/types/objects';

interface ManagerMembershipFlags {
  is_manager?: boolean;
  isManager?: boolean;
}

interface ManagerRelationUser {
  id?: string;
  manager?: SimpleUser | null;
}

export function getIsManagerFlag(membership?: ManagerMembershipFlags | null): boolean {
  if (!membership) return false;
  return Boolean(membership.is_manager ?? membership.isManager);
}

export function isDirectManagerOf(
  profileUser: ManagerRelationUser | ExtendedUser | LoggedUser | null | undefined,
  loggedUserId?: string | null,
): boolean {
  if (!profileUser?.manager?.id || !loggedUserId) return false;
  return String(profileUser.manager.id) === String(loggedUserId);
}
